module.exports = __webpack_public_path__ + "img/246.b2f9bf9e.jpg";